import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase
} from "@angular/common/http";
import { map } from "rxjs/operators";

import * as FileSaver from "file-saver";
import * as XLS from "xlsx";
import * as XLSX from "xlsx";
import { environment } from "src/environments/environment";
import { CiCdConfigService } from "src/cicd/ci-cd-config.service";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xls";

@Injectable({
  providedIn: "root"
})
export class SubirArchivoService {
  public headers: any;
  public userData: any;
  private urlApi: string;
  // urlDescarga = 'http://192.168.87.233/covirecupera-externo/Formato-cargue-micovinoc.xlsx';
  public downloadUrl =
    "http://200.41.76.20/CoviRecuperaAfiliado/Formato_cargue_cartera_CoviRecupera.xlsx";

  constructor(private http: HttpClient,
    private readonly ciCd: CiCdConfigService
  ) {
    // this.urlApi = environment.urlApi; // PREJENKINS
    this.ciCdInit();
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/x-www-form-urlencoded");
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
  }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApi } = apis;
      this.urlApi = urlApi;
    });
  }

  dwonloadExcelTemplate(data?: any) {
    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.get(`${this.urlApi}/exportar_descarga_guia`, {
      headers: options.headers,
      responseType: "blob"
    });
  }

  uploadFile(data: any, dataFile: File, urlApiSendFiles: string) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/x-www-form-urlencoded");
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    data.verificar = "1";
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.id_pais = this.userData.v_pais;
    data.usuario = this.userData.v_usuario;
    data.modulo = "externo";
    data.tipo_documentoc = this.userData.v_tipo_documento; // doc afiliado
    data.documentoc = this.userData.v_documento; // tipo doc afiliado

    const headers = this.headers;
    const options = { params: data, headers };
    const formData: FormData = new FormData();
    const file = dataFile;
    formData.append("file", file, file.name);

    return this.http.put<any>(
      `${this.urlApi}/${urlApiSendFiles}`,
      formData,
      options
    );
  }

  jsonValidate(data: any, body: any, urlApiSendFiles: string) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/x-www-form-urlencoded");
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    data.verificar = "1";
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.id_pais = this.userData.v_pais;
    data.usuario = this.userData.v_usuario;
    data.modulo = "externo";
    data.tipo_documentoc = this.userData.v_tipo_documento;
    data.documentoc = this.userData.v_documento;

    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.put<any>(
      `${this.urlApi}/${urlApiSendFiles}`,
      body,
      options
    );
  }

  jsonToExcel(data: any, body: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/json");
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    // datos.verificar = '1';
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.id_pais = this.userData.v_pais;
    data.usuario = this.userData.v_usuario;
    // datos.modulo = 'externo';
    // datos.tipo_documentoc = this.DatosUsuario.v_tipo_documento;
    // datos.documentoc = this.DatosUsuario.v_documento;

    delete data.verificar;
    delete data.modulo;
    delete data.usuario;
    delete data.tipo_documentoc;
    delete data.documentoc;

    const headers = this.headers;

    const httpOption: Object = {
      observe: "response",
      params: data,
      headers: this.headers,
      responseType: "blob"
    };

    return this.http
      .post<any>(`${this.urlApi}/pr_exportar_convertir_a_xls`, body, httpOption)
      .pipe(
        map((res: HttpResponseBase) => {
          return {
            filename: "registros_erroneos_cr.xls",
            data: new Blob([res["body"]], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
          };
        })
      );
  }

  upload(data: any, body: any, urlApiSendFiles: string) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/x-www-form-urlencoded");
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    data.verificar = "0";
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.id_pais = this.userData.v_pais;
    data.usuario = this.userData.v_usuario;
    data.modulo = "externo";
    data.tipo_documentoc = this.userData.v_tipo_documento;
    data.documentoc = this.userData.v_documento;

    const headers = this.headers;
    const options = { params: data, headers };
    return this.http.put<any>(
      `${this.urlApi}/${urlApiSendFiles}`,
      body,
      options
    );
  }

  dwonloadFile(datos?: any) {
    const headers = this.headers;
    const options = { params: datos, headers };
    return this.http.get(this.downloadUrl, { responseType: "blob" }).pipe(
      map((res: any) => {
        return new Blob([res.blob()], { type: "application/vnd.ms-excel" });
      })
    );
  }

  static toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile2(json: any[], excelFileName: string): void {
    const configurator = [
      "TIPO_DOCUMENTO",
      "DOCUMENTO",
      "NOMBRE_DEUDOR",
      "TITULO",
      "OBLIGACION",
      "FECHA_VENCIMIENTO",
      "VALOR_DEUDA",
      "DIRECCION",
      "TELEFONO_1",
      "TELEFONO_2",
      "EMAIL",
      "CIUDAD_DIRECCION"
    ];

    const json2 = [
      {
        TIPO_DOCUMENTO:
          "C = Cedula de ciudadania\n N = Nit E= Cedula de extranjería\n P = Pasaporte\n T = tarjeta de identidad",
        DOCUMENTO: "Sin puntos, comas o espacios",
        NOMBRE_DEUDOR: "nombres y apellidos",
        TITULO:
          "FACTURA\n CHEQUE\n PAGARE\n CONTRATO\n LETRA\n LIBRANZA\n TARJETA\n CREDITO\n POLIZA",
        OBLIGACION: "Sin puntos, comas o espacios",
        FECHA_VENCIMIENTO: "año-mes-dia:en numeros",
        VALOR_DEUDA: "Sin puntos, comas o espacios",
        DIRECCION: "cra 00 # 00 - 00",
        TELEFONO_1: "7 dígitos para fijo\n - 10 dígitos para celular",
        TELEFONO_2:
          "7 dígitos para fijo\n - 10 dígitos para celular PARA AGREGAR\n MAS IMPORTANTE NO AGREGAR COLUMNAS,\n EN SU LUGAR SEPARARLOS POR COMAS",
        EMAIL:
          "ejemplo@ejemplo.com PARA AGREGAR MAS\n IMPORTANTE NO AGREGAR COLUMNAS,\n EN SU LUGAR SEPARARLOS POR COMAS",
        CIUDAD_DIRECCION: "Bogota"
      }
    ];

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
      header: configurator
    });
    const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json2, {
      header: configurator
    });
    const workbook: XLSX.WorkBook = {
      Sheets: { Cargue: worksheet, Guia: worksheet2 },
      SheetNames: ["Cargue", "Guia"]
    };

    const wscols = [
      { wch: 80 },
      { wch: 30 },
      { wch: 20 },
      { wch: 70 },
      { wch: 30 },
      { wch: 30 },
      { wch: 30 },
      { wch: 40 },
      { wch: 40 },
      { wch: 100 },
      { wch: 90 },
      { wch: 40 }
    ];

    worksheet2["!cols"] = wscols;

    XLSX.writeFile(
      workbook,
      SubirArchivoService.toExportFileName(excelFileName)
    );
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const configurator = [
      "TIPO_DOCUMENTO",
      "DOCUMENTO",
      "NOMBRE_DEUDOR",
      "TITULO",
      "OBLIGACION",
      "FECHA_VENCIMIENTO",
      "VALOR_DEUDA",
      "DIRECCION",
      "TELEFONO_1",
      "TELEFONO_2",
      "EMAIL",
      "CIUDAD_DIRECCION",
      "MENSAJE",
      "ID",
      "ERROR"
    ];

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
      header: configurator
    });
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"]
    };
    XLSX.writeFile(
      workbook,
      SubirArchivoService.toExportFileName(excelFileName)
    );
  }

  public exportRefundsAsExcelFile(json: any[], excelFileName: string): void {
    const configurator = [
      // 'TIPO_DOCUMENTO', 'DOCUMENTO', 'NOMBRE_DEUDOR', 'TITULO', 'OBLIGACION', 'FECHA_VENCIMIENTO',
      // 'VALOR_DEUDA', 'DIRECCION', 'TELEFONO_1', 'TELEFONO_2', 'EMAIL', 'CIUDAD_DIRECCION',
      // 'MENSAJE', 'ID', 'ERROR'
    ];

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
      header: configurator
    });
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"]
    };
    XLSX.writeFile(
      workbook,
      SubirArchivoService.toExportFileName(excelFileName)
    );
  }

  excel() {
    const headers = this.headers;
    const options = { headers };
    return this.http.get(`${this.urlApi}/exportar_convertir_a_xls`, {
      responseType: "blob"
    });
  }

  /// ultima prueba

  convertToXslx(data: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/json");
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    data.tipo_documento = this.userData.v_tipo_documento;
    data.documento = this.userData.v_documento;
    data.id_pais = this.userData.v_pais;
    data.usuario = this.userData.v_usuario;

    delete data.verificar;
    delete data.modulo;
    delete data.usuario;
    delete data.tipo_documentoc;
    delete data.documentoc;

    const headers = this.headers;

    const httpOption: Object = {
      observe: "response",
      params: data,
      headers: this.headers,
      responseType: "blob"
    };

    return this.http.get(`${this.urlApi}/pr_convertir_a_xls`, httpOption);
  }

  downloadRejections(radicado: string) {
    this.headers.append("Content-Type", "multipart/form-data");
    this.headers.append("Accept", "application/x-www-form-urlencoded");
    const headers = this.headers;
    const options = { headers };
    return this.http.get(
      `${this.urlApi}/exportar_rechazos_cm?radicado=${radicado}`,
      { headers: options.headers, responseType: "blob" }
    );
  }
}
